import { createTheme } from '@mui/material/styles';
import Pretendard from '@/fonts/PretendardVariable.woff2';

import type { Theme } from '@mui/material/styles';

export const MuiTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Pretendard';
          font-style: normal;
          font-display: swap;
          src: local('Pretendard'), url(${Pretendard}) format('woff2');
        }
      `,
    },
  },
  typography: {
    fontFamily: [
      // reference: https://github.com/orioncactus/pretendard?tab=readme-ov-file#font-family
      'Pretendard',
      '-apple-system',
      'BlinkMacSystemFont',
      'system-ui',
      'Roboto',
      '"Helvetica Neue"',
      '"Segoe UI"',
      '"Apple SD Gothic Neo"',
      '"Noto Sans KR"',
      '"Malgun Gothic"',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      'sans-serif',
    ].join(','),
    button: { textTransform: 'none' },
  },
  palette: {
    primary: {
      main: '#0096D1',
    },
    secondary: {
      main: '#4FD1C5',
    },
    info: {
      main: '#2D3748',
    },
  },
});

export const adminTheme = (theme: Theme) =>
  createTheme({
    ...theme,
    palette: {
      bg: {
        dark: '#212529',
        main: '#F7F7F7',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            paddingLeft: 16,
            paddingRight: 16,
            backgroundColor: '#212529',
            color: 'white',
          },
        },
      },
    },
  });
